import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Layout from "../../../components/Layout/MembersPortalLayout/MembersPortalLayout";

import { ApiResponse } from "../../../interface/IResponse";

import { LoanStatusDetails } from "../../../interface/MembersPortal/ILoan";

import loanService from "./loanService";

import ApplicationForLoanForm from "../../../components/LoanApplicationForms/ApplicationForLoanForm";
import DisclosureStatementLoanCreditTransactionForm from "../../../components/LoanApplicationForms/DisclosureStatementLoanCreditTransactionForm";
import CertificateForm from "../../../components/LoanApplicationForms/CertificateForm";


function PreviewLoanApplicationForm() {

    const navigate = useNavigate();

    const [loanStatusDetails, setLoanStatusDetails] = useState<LoanStatusDetails | null>(null);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [isDisclosureOpen, setIsDisclosureOpen] = useState(false);
    const [isCertificationOpen, setIsCertificationOpen] = useState(false);

    const { loanId } = useParams<{ loanId: string }>();

    async function loadLoanStatusDetails() {
        try {
            var axiosResponse = await loanService.getLoanStatusDetails(Number(loanId));
            var response: ApiResponse<LoanStatusDetails> = axiosResponse.data;
            setLoanStatusDetails(response.result);
        }
        catch (err) {
            console.log('loadLoanStatusDetails err: ', err);
        }
    }

    useEffect(function () {
        (async () => {
            document.querySelector('.loader-container')?.classList.add('loader');
            await loadLoanStatusDetails();
            document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, []);

    return (
        <Layout>

            <div className="title-container">
                <div>
                    <div className="dv-title">
                        <h1>Loan Application Form</h1>
                    </div>
                </div>
                <div className="title-btn-container vertical-flex-bottom">
                    <button
                        type="button"
                        id="btnBack"
                        onClick={() => { navigate(`/Members/LoanStatusDetails/${loanId}`); }}
                        className="btn-white-green-2 center-middle"
                    >
                        Back
                    </button>
                </div>
            </div>

            <br />

            <div className="accordion-item" style={{ marginBottom: '16px' }}>
                <div className={`accordion-header ${isFormOpen ? 'active' : ''}`} onClick={() => setIsFormOpen(prev => !prev)}>
                    <span>Application For Loan</span>
                </div>
                <div className={`accordion-body ${isFormOpen ? 'open' : ''}`}>
                    <ApplicationForLoanForm loanId={loanId} loanStatusDetails={loanStatusDetails} />
                </div>
            </div>

            <div className="accordion-item" style={{ marginBottom: '16px' }}>
                <div className={`accordion-header ${isDisclosureOpen ? 'active' : ''}`} onClick={() => setIsDisclosureOpen(prev => !prev)}>
                    <span>Disclosure Statement of Loan or Credit Transaction</span>
                </div>
                <div className={`accordion-body ${isDisclosureOpen ? 'open' : ''}`}>
                    <DisclosureStatementLoanCreditTransactionForm loanId={loanId} loanStatusDetails={loanStatusDetails} />
                </div>
            </div>

            <div className="accordion-item">
                <div className={`accordion-header ${isCertificationOpen ? 'active' : ''}`} onClick={() => setIsCertificationOpen(prev => !prev)}>
                    <span>Certification</span>
                </div>
                <div className={`accordion-body ${isCertificationOpen ? 'open' : ''}`}>
                    <CertificateForm loanId={loanId} loanStatusDetails={loanStatusDetails} />
                </div>
            </div>

        </Layout>
    );
}


export default PreviewLoanApplicationForm;
